import * as React from 'react';

import { createIcon } from '../Icon';
export const DropletIcon = createIcon(
  <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />,
  'DropletIcon'
);
